import { joinPath } from '../../core/utils';
import type { NetworkBlockOptions, NetworkPaths } from './types';

function fieldSuffix(options?: NetworkBlockOptions): string {
  return options?.flatFields ? '' : '.name';
}

/** 按 pathPrefix + options 生成 form 路径 */
export function resolveNetworkPaths(prefix: string, options?: NetworkBlockOptions): NetworkPaths {
  const suffix = fieldSuffix(options);
  const sgSegment = options?.securityGroupSegment ?? 'securitygroup';
  const paths: NetworkPaths = {
    vpc: joinPath(prefix, `vpc${suffix}`),
    subnet: joinPath(prefix, `subnet${suffix}`),
    securitygroup: joinPath(prefix, `${sgSegment}${suffix}`),
  };

  if (options?.showStaticIpv4 || options?.showStaticIpv4WhenAdopt) {
    paths.staticIpv4 = joinPath(prefix, 'staticIpv4');
  }

  if (options?.showDisplayNameFields) {
    paths.vpcDisplayName = joinPath(prefix, 'vpcDisplayName');
    paths.securityGroupDisplayName = joinPath(prefix, 'securityGroupDisplayName');
  }

  return paths;
}
